import {ChangeDetectionStrategy, Component, computed, Signal, viewChild} from "@angular/core";
import {navParam} from "../../navigation/navigation-params";
import {Page} from "../../navigation/page";
import {EmailFieldComponent} from '../../inputs/email-field/email-field.component';
import {FormComponent} from '../../inputs/form/form.component';
import {PhoneNumberFieldComponent} from '../../inputs/phone-number-field/phone-number-field.component';
import {TextFieldComponent} from '../../inputs/text-field/text-field.component';
import {ModalPageLayoutComponent} from '../../page-layout/modal-page-layout/modal-page-layout.component';
import {FormsModule} from '@angular/forms';
import {PhoneNumberDirective} from '../../inputs/phone-number-field/phone-number.directive';
import {EmailDirective} from '../../inputs/email-field/email.directive';
import {ButtonComponent} from '../../buttons/button/button.component';
import {PageFooterControlDirective} from '../../page-layout/page-footer-control.directive';

@Component({
    selector: "woa-marketing-entry-page",
    templateUrl: "./marketing-entry-page.component.html",
    providers: [{provide: Page, useExisting: MarketingEntryPageComponent}],
    imports: [
        ButtonComponent,
        EmailDirective,
        EmailFieldComponent,
        FormComponent,
        FormsModule,
        ModalPageLayoutComponent,
        PageFooterControlDirective,
        PhoneNumberDirective,
        PhoneNumberFieldComponent,
        TextFieldComponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MarketingEntryPageComponent extends Page {
    public readonly form: Signal<FormComponent> = viewChild.required(FormComponent);

    readonly showMobilePhone: Signal<boolean> = navParam.required<boolean>("showMobilePhone");
    readonly showEmail: Signal<boolean> = navParam.required<boolean>("showEmail");
    readonly showPostCode: Signal<boolean> = navParam.required<boolean>("showPostCode");

    readonly instructions: Signal<string> = computed(() =>
        this.showMobilePhone() && this.showEmail() ? "woa.message.marketing.instructions.marketingOptIn.mobilePhoneAndEmail"
            : this.showMobilePhone() ? "woa.message.marketing.instructions.marketingOptIn.mobilePhone"
                : this.showEmail() ? "woa.message.marketing.instructions.marketingOptIn.email"
                    : "woa.message.marketing.instructions.marketingOptIn.postCode");

    mobilePhone: string;
    email: string;
    postCode: string;

    confirmDetails(): void {
        if (!this.form().valid) {
            return;
        }

        void this.dismiss({
            confirmed: true,
            mobilePhone: this.mobilePhone,
            email: this.email,
            postCode: this.postCode
        });
    }
}
